import angular from 'angular';
import {companyBalanceSheetComponent} from "./company-balance-sheet.component";

export const CompanyBalanceSheetModule =
    angular.module("company-balance-sheet-module", [])
        .component("companyBalanceSheet", companyBalanceSheetComponent)
        .name;